module.exports = __webpack_public_path__ + "static/img/login_pic.ff69516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_pic.jpg
// module id = dvL3
// module chunks = 1